import React, { useMemo, useState } from 'react';
import { getBrandImage } from '../../data/brandImages';
import { FAQ_TOPICS, DEFAULT_SITE_CONTACT } from '../../data/siteContent';
import { BrandStrip } from './ClientLayout';
import { PageHero } from './HomePage';

const HelpPage = ({ setCurrentView, siteConfig }) => {
  const [open, setOpen] = useState('ingreso');
  const [search, setSearch] = useState('');
  const contact = { ...DEFAULT_SITE_CONTACT, ...(siteConfig?.contacto || {}) };
  const wa = `https://wa.me/${String(contact.whatsapp || '').replace(/\D/g, '')}`;

  const topics = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return FAQ_TOPICS;
    return FAQ_TOPICS.filter((t) => `${t.title} ${t.body}`.toLowerCase().includes(term));
  }, [search]);

  return (
    <div>
      <PageHero
        image={getBrandImage(siteConfig, 'heroAyuda')}
        title="¿En qué podemos ayudarte?"
        subtitle="Estamos para que tu experiencia en Maja Club siempre sea una gran experiencia."
        scripts={['Buenas preguntas, grandes respuestas']}
      >
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Buscá tu consulta..."
          className="mt-6 w-full max-w-md h-12 px-5 rounded-full bg-white/95 text-maja-ink focus:outline-none"
        />
      </PageHero>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-1">
          <h2 className="text-2xl font-black mb-4">Temas frecuentes</h2>
          <div className="rounded-2xl border border-gray-100 overflow-hidden divide-y divide-gray-100">
            {topics.map((topic) => (
              <button
                key={topic.id}
                onClick={() => setOpen(open === topic.id ? '' : topic.id)}
                className="w-full text-left px-5 py-4 hover:bg-black/[0.02]"
              >
                <div className="flex items-center justify-between font-semibold tracking-tight">
                  <span>{topic.title}</span>
                  <span className="text-maja-ink/30">{open === topic.id ? '−' : '+'}</span>
                </div>
                {open === topic.id && (
                  <p className="mt-2 text-sm text-maja-ink/60 font-normal leading-relaxed">{topic.body}</p>
                )}
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-5">
          <div className="rounded-2xl border border-green-100 bg-green-50 p-6">
            <h3 className="font-black text-lg">¿Seguís con dudas?</h3>
            <p className="text-sm text-gray-600 mt-1">Escribinos por WhatsApp. Te ayudamos de lunes a domingo.</p>
            <a
              href={wa}
              target="_blank"
              rel="noreferrer"
              className="mt-4 inline-flex h-10 px-5 rounded-full bg-green-600 text-white font-extrabold items-center"
            >
              Abrir WhatsApp →
            </a>
          </div>
          {(contact.email || contact.telefono) && (
            <div className="rounded-2xl border border-gray-100 p-6">
              <h3 className="font-black mb-3">Otras formas de contacto</h3>
              {contact.email && (
                <p className="text-sm text-maja-ink/70"><span className="font-semibold text-maja-ink">Email:</span> {contact.email}</p>
              )}
              {contact.telefono && (
                <p className="text-sm mt-1 text-maja-ink/70"><span className="font-semibold text-maja-ink">Teléfono:</span> {contact.telefono}</p>
              )}
            </div>
          )}
        </div>

        <div className="space-y-4">
          <h3 className="text-2xl font-black">Consejos útiles</h3>
          {[
            { title: 'Cómo sumar más puntos', view: 'howItWorks', image: getBrandImage(siteConfig, 'ayudaConsejo1') },
            { title: 'Cómo canjear tus beneficios', view: 'canjes', image: getBrandImage(siteConfig, 'ayudaConsejo2') },
            { title: 'Conocé los beneficios del club', view: 'benefits', image: getBrandImage(siteConfig, 'ayudaConsejo3') },
          ].map((card) => (
            <button
              key={card.title}
              onClick={() => setCurrentView(card.view)}
              className="relative w-full h-28 rounded-[1.4rem] overflow-hidden text-left"
            >
              <img src={card.image} alt="" className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0 bg-black/45" />
              <p className="relative z-10 p-4 text-white font-semibold tracking-tight">{card.title}</p>
            </button>
          ))}
        </div>
      </section>

      <BrandStrip
        setCurrentView={setCurrentView}
        title="Tu experiencia también nos importa."
        cta="Volver al inicio"
        target="home"
      />
    </div>
  );
};

export default HelpPage;
